import { Text, View } from "components/ui";
import React from "react";

type Props = {
	notificationCount: number;
	notificationColor: string;
};

const NotificationBadge = (props: Props) => {
	const { notificationCount, notificationColor } = props;
	let renderedNotificationColor = "";
	let renderedTextColor = "";
	switch (notificationColor) {
		case "danger":
			renderedNotificationColor = "$errorbright";
			renderedTextColor = "$basicwhite";
			break;
		case "success":
			renderedNotificationColor = "$successbright";
			renderedTextColor = "$basicwhite";
			break;
		case "warning":
			renderedNotificationColor = "$warningbright";
			renderedTextColor = "$basicwhite";
			break;
		default:
			renderedNotificationColor = "$successbright";
			renderedTextColor = "$basicwhite";
	}
	return (
		<View borderRadius="$full" alignItems="center" justifyContent="center" width={24} height={24} backgroundColor={renderedNotificationColor}>
			<Text color={renderedTextColor} size="sm">
				{notificationCount}
			</Text>
		</View>
	);
};

export default NotificationBadge;
